import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propFunc, propNumber, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import CustomSlider from '../../Slider';
import NextButton from './Button/NextButton';
import PrevButton from './Button/PrevButton';
import ImageSlider from './ImageSlider';
const SlideList = (props) => {
    const { changeImageIndexMap, changeSlideListIndex, className, containerId, imageIndexMap, scrollingRef, setSliderRef, slideListIndex, sliderListClassName, slides, } = props;
    const config = useMemo(() => ({
        accessibility: false,
        afterChange: changeSlideListIndex,
        arrows: true,
        infinite: false,
        initialSlide: slideListIndex,
        rows: 1,
        slidesToShow: 1,
        speed: 300,
    }), [changeSlideListIndex, slideListIndex]);
    return (_jsx(CustomSlider, Object.assign({ className: sliderListClassName, config: config, customNextArrow: NextButton, customPrevArrow: PrevButton, setSliderRef: setSliderRef }, { children: slides.map((slide, index) => (_jsx(ImageSlider, { changeImageIndexMap: changeImageIndexMap, className: className, containerId: containerId, imageIndex: imageIndexMap[index] || 0, images: slide.pages, scrollingRef: scrollingRef, slideListIndex: index }, slide.id))) })));
};
SlideList.propTypes = {
    changeImageIndexMap: propFunc().isRequired,
    changeSlideListIndex: propFunc().isRequired,
    className: propStr().isRequired,
    containerId: propStr().isRequired,
    imageIndexMap: propShape().isRequired,
    scrollingRef: propShape().isRequired,
    setSliderRef: propFunc().isRequired,
    slideListIndex: propNumber().isRequired,
    sliderListClassName: propStr().isRequired,
    slides: propArrayShape().isRequired,
};
export default SlideList;
